import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";

const srcSetList = [
  [240, 238],
  [320, 317],
  [480, 476],
  [640, 634],
  [750, 714],
  [960, 952]
];

const getSrcSet = src =>
  srcSetList
    .map(
      ([presetSize, ourSize]) =>
        `//${src}?$n_${presetSize}w$&wid=${ourSize}&fit=constrain ${ourSize}w`
    )
    .join(",");

const Image = ({ className, src, onLoad }) => (
  <img
    alt={""}
    className={classnames(className, styles.image)}
    data-auto-id="productTileImage"
    sizes="(min-width: 768px) 317px, 238px"
    src={`//${src}?$n_480w$&wid=476&fit=constrain`}
    srcSet={getSrcSet(src)}
    onLoad={onLoad}
  />
);

Image.propTypes = {
  className: PropTypes.string,
  onLoad: PropTypes.func,
  src: PropTypes.string.isRequired
};

Image.defaultProps = {
  onLoad: () => {}
};

export default Image;
